module.exports = __webpack_public_path__ + "static/media/rule-and-activity.3ce0770b.svg";